import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../services/property.service';
import { NavigationContextService } from '../../services/navigation-context.service';

@Component({
  selector: 'app-property-context',
  templateUrl: './property-context.component.html',
  styleUrls: ['./property-context.component.scss']
})
export class PropertyContextComponent implements OnInit, OnChanges {
  @Input() property: any;
  /** Current page name for breadcrumb, e.g. "Leases" */
  @Input() pageLabel: string = null;
  propertyId: string | null = null;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private propertyService: PropertyService,
    private navContext: NavigationContextService
  ) { }

  ngOnInit() {
    if (this.property && this.property.id) {
      this.navContext.setPropertyId(this.property.id);
      return;
    }

    this.propertyId = this.route.snapshot.queryParamMap.get('propertyId')
      || this.navContext.propertyId;
    if (this.propertyId) {
      this.loading = true;
      this.propertyService.getPublicProperty(this.propertyId).then(property => {
        this.property = property;
        this.navContext.setPropertyId(property && property.id);
        this.loading = false;
      }).catch(error => {
        console.error('Error loading property:', error);
        this.loading = false;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['property'] && this.property && this.property.id) {
      this.navContext.setPropertyId(this.property.id);
    }
  }

  goToProperty() {
    if (this.property && this.property.id) {
      this.navContext.goToPropertyHub(this.property.id);
    }
  }

  goToDashboard() {
    this.navContext.goToDashboard();
  }
}
